export default {"src":"/_next/static/media/bch.71acc717.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};